const CONTACT_US_OPEN_MODAL = 'contact-us-open-modal';
const CONTACT_US_CLOSE_MODAL = 'contact-us-close-modal';

export { CONTACT_US_OPEN_MODAL, CONTACT_US_CLOSE_MODAL };
